import { AnyAction } from "redux"

import {
  CLOSE_MODAL,
  OPEN_MODAL,
  SET_PRODUCT,
  CLEAR_PRODUCT,
  SET_PRODUCT_LIST_CALL,
  SET_PRODUCT_LIST_SUCCESS,
  SET_PRODUCT_LIST_FAILURE,
  SET_PRODUCT_IDENTIFIERS,
  PRODUCT_INFO_CALL,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_INFO_FAILURE
} from "./actions-types"

interface ProductInfo {
  id: string
  name: string
  prefixUrl: string
  isFederated: boolean
  isExternal: boolean
  federatedKey: string
  productInfo: {
    image: string
    federationUrl: string
    logoUrl: string
    docLink?: string
    externalApiUrl: string
    externalApiAuthUrl: string
    supportEmail: string
    authKey: string
    authMethod: string
    productLandingPageURL: string
    description: string
    isPublished?: boolean
    docTitle: string
    docDescription: string
  }
  federationFields: [{ key: string; label: string; type: string; externalEndpointUrlForFileManagement: string }]
  marketplaceInfo: {
    benefits: string[]
    bannerInfo: {
      bannerImageUrl: string
      color: string
      isGradient: boolean
    }
  }
}

const productInitialState: ProductInfo = {
  id: "",
  name: "",
  prefixUrl: "",
  isFederated: false,
  isExternal: false,
  federatedKey: "",
  productInfo: {
    image: "",
    federationUrl: "",
    logoUrl: "",
    docLink: "",
    externalApiUrl: "",
    externalApiAuthUrl: "",
    supportEmail: "",
    authKey: "",
    authMethod: "",
    productLandingPageURL: "",
    description: "",
    isPublished: true,
    docTitle: "",
    docDescription: ""
  },
  federationFields: [{ key: "", label: "", type: "", externalEndpointUrlForFileManagement: "" }],
  marketplaceInfo: {
    benefits: [],
    bannerInfo: {
      bannerImageUrl: "",
      color: "",
      isGradient: false
    }
  }
}

export interface ProductState {
  modal: {
    type: "create" | "update" | "delete" | "unpublish" | ""
    state: boolean
  }
  product: ProductInfo
  productList: {
    data: App.Product[]
    loading: boolean
    error: string
  }
  identifiers: {
    productPrefixUrl: string
    productId: string
  }
  productInfo: {
    data: App.Product
    loading: boolean
    error: string
  }
}

const INITIAL_STATE: ProductState = {
  modal: {
    type: "",
    state: false
  },
  product: productInitialState,
  productList: {
    data: [],
    loading: false,
    error: ""
  },
  identifiers: {
    productPrefixUrl: "",
    productId: ""
  },
  productInfo: {
    data: productInitialState,
    loading: false,
    error: ""
  }
}

//This redux reducer is used to manage the state of the products
export default function productReducer(state: ProductState = INITIAL_STATE, action: AnyAction): ProductState {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modal: {
          type: action.payload.type,
          state: true
        }
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modal: {
          type: "",
          state: false
        }
      }
    case SET_PRODUCT:
      return {
        ...state,
        product: action.payload
      }
    case CLEAR_PRODUCT:
      return {
        ...state,
        product: INITIAL_STATE.product
      }
    case SET_PRODUCT_LIST_CALL:
      return {
        ...state,
        productList: {
          ...state.productList,
          loading: true
        }
      }
    case SET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        productList: {
          data: action.payload as App.Product[],
          loading: false,
          error: ""
        }
      }
    case SET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        productList: {
          ...state.productList,
          loading: false,
          error: action.payload as string
        }
      }
    case SET_PRODUCT_IDENTIFIERS:
      return {
        ...state,
        identifiers: {
          productPrefixUrl: action.payload.productPrefixUrl,
          productId: action.payload.productId
        }
      }

    case PRODUCT_INFO_CALL:
      return {
        ...state,
        productInfo: {
          ...state.productInfo,
          loading: true
        }
      }

    case PRODUCT_INFO_SUCCESS:
      return {
        ...state,
        productInfo: {
          data: action.payload,
          loading: false,
          error: ""
        }
      }

    case PRODUCT_INFO_FAILURE:
      return {
        ...state,
        productInfo: {
          ...state.productInfo,
          loading: false,
          error: action.payload
        }
      }

    default:
      return state
  }
}
